export enum ErrorCode {
  EmailConfirmationRequired = 'EmailConfirmationRequired',
  ForbiddenDataAccess = 'ForbiddenDataAccess',
  TwoFactorRequired = 'TwoFactorRequired',
  TwoFactorChallengeExpired = 'TwoFactorChallengeExpired',
  TwoFactorSetupRequired = 'TwoFactorSetupRequired',
  TwoFactorSetupRequiredForAdminAction = 'TwoFactorSetupRequiredForAdminAction',
  TwoFactorInvalidCode = 'TwoFactorInvalidCode',
  RecoveryCodeGenerationFailed = 'RecoveryCodeGenerationFailed',
  TwoFactorAlreadyEnabled = 'TwoFactorAlreadyEnabled',
  TwoFactorEnableFailed = 'TwoFactorEnableFailed',
}

export interface ErrorObject {
  status: number;
  message: string;
  code: ErrorCode | null;
}